import { SetStateAction, useEffect, useMemo, useState } from 'react'

import debounce from 'debounce'
import { Select } from 'flowbite-react'
import { useParams } from 'react-router-dom'

import Loader from '@/components/Loader'
import TableItem from '@/components/Table'
import PaginationItem from '@/components/Table/pagination-item'
import SearchTableItem from '@/components/Table/search'
import { useGetRepasses } from '@/hooks/queries/use-get-pedidos'
import { TABLE_HEADERS_LANCAMENTOS_PEDIDO } from '@/pages/Pedidos/constants'


const DetailTaxasPedido = () => {
  const { id } = useParams()
  const [search, setSearch] = useState('')
  const [repassesPage, setRepassesPage] = useState<number>(1)
  const [repassesPageSize, setRepassesPageSize] = useState(10)
  const repassesInicio = (repassesPage - 1) * repassesPageSize
  const { data: repassesList, isIdle, isLoading: isTaxasLoading } = useGetRepasses({
    params: {
      pedidoId: id,
      inicio: repassesInicio,
      comprimento: repassesPageSize,
      procurar: search,
      tipo: 'Tarifas'
    }
  })
  
  const handleSearch = debounce((e: SetStateAction<string>) => {
    if (e.length >= 2) {
      setSearch(e)
    } else {
      setSearch('')
    }
  }, 500)

  const repassesTotalPages = Math.ceil(
    (repassesList?.conteudo?.quantidadeDeItems ?? 0) / repassesPageSize
  )
  const mappedTarifas = useMemo(() => {
    return repassesList?.conteudo?.resultados?.map(item => {
      return {
        descricao: item.descricao,
        valor: item.valorTotal.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL'
        }),
        valorRaw: item.valorTotal
      }
    })
  }, [repassesList])

  const valorTotalTarifas = mappedTarifas
    ?.reduce((acc, item) => acc + item.valorRaw, 0)
    .toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })


  useEffect(() => {
    repassesPage > 1 && setRepassesPage(1)
  }, [repassesPageSize])

  return (
    <div className='overflow-x-auto'>
      <SearchTableItem
        isAddItem={false}
        isSearchInputEnabled={true}
        setFilterText={e => handleSearch(e)}
      />
      {isTaxasLoading ? (
        <div
          className='h-96 w-full flex justify-center items-center'
          data-testid='loader-taxas'
        >
          <Loader size={'xl'} />
        </div>
      ) : (
        <TableItem
          isActions={false}
          isRowClicable={false}
          data={mappedTarifas || []}
          headers={TABLE_HEADERS_LANCAMENTOS_PEDIDO}
          deleteAction={() => void 0}
          hasCustomActions={false}
          idKey='pedidoId'
          isIdle={isIdle}
        />
      )}
      {!!mappedTarifas?.length && (
        <div className='w-full pt-5 flex items-center justify-end'>
          <span className='font-bold text-xl'>
            Valor total geral:{' '}
            <span className='text-quaternary'>{valorTotalTarifas}</span>
          </span>
        </div>
      )}
      <PaginationItem
        totalItems={
          repassesList?.conteudo?.quantidadeDeItems ?? 0
        }
        totalPages={repassesTotalPages}
        pageSize={repassesPageSize}
        onPageChange={(pageParam: number) => setRepassesPage(pageParam)}
        forceDisplay={true}
      >
        <Select
          id='select-page-size'
          data-testid='select-page-size'
          onChange={e => setRepassesPageSize(Number(e.target.value))}
          defaultValue={repassesPageSize}
        >
          <option value='10'>10</option>
          <option value='25'>25</option>
          <option value='50'>50</option>
          <option value='100'>100</option>
        </Select>
      </PaginationItem>
    </div>
  )
}

export default DetailTaxasPedido
